<template>
    <div>
         <v-progress-linear
        :indeterminate = "true"
        :active="loading"
        :color="color"
        d-flex
        class="rounded"
        height="8"
        align="center"
        justify="center"
        ></v-progress-linear>
        <center v-if="loading">
            Loading. Please wait    
        </center>
    </div>
</template>

<script>
export default {
    props:{
        loading:{
            type:Boolean
        },
        color:{
            type:String,
            default:'#F36F2E'
        },
    }
}
</script>

<style lang="scss" scoped>
center{
    font-size: 18px;
    margin-top: 20px;
    color: #636366;
    font-weight: 600;
}
</style>